/* Wordmark drawn in the page's own type, so it always matches the palette */
export const BrandMark = ({ size = 'md', testId = 'header-logo' }) => {
  const sizes = {
    sm: 'text-xl md:text-2xl',
    md: 'text-2xl md:text-3xl',
  };

  return (
    <div
      className={`shrink-0 leading-none select-none font-sans text-[#E0C07A]/90 ${sizes[size] || sizes.md}`}
      style={{ letterSpacing: '0.08em', lineHeight: 1, fontWeight: 400 }}
      data-testid={testId}
    >
      PA
    </div>
  );
};
